import axios from 'axios'
import { getToken,nowTimes,getAesCode,getApiSign } from '@/utils/auth.js'
import { Message } from 'element-ui'
import store from '../store'
let requestCount;
// console.log(process.env.VUE_APP_BASE_API,'https')
const service = axios.create({
    baseURL:process.env.VUE_APP_APIS, // url = base url + request url
    // baseURL:'http://192.168.1.239:8087',
    timeout: 300000 // request timeout
})
 
service.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.transformRequest = [function (data) {
            let encrypted_data_obj = JSON.parse(localStorage.getItem('encrypted_data')) || {}
            encrypted_data_obj.timestamp = nowTimes()
            data['encrypted_data'] = getAesCode(encrypted_data_obj)
            data['client_id'] = '74450c23fa139888c2240568a276879d'
            data['token'] = getToken()
            data['sign'] = getApiSign(data)
            let ret = ''
            for (const it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            ret = ret.substr(0, ret.length - 1)
            return ret
        }]
        if (config.url.indexOf('School/getSingleSpecia') == -1 && config.url.indexOf('user/login') == -1 && config.url.indexOf('user/send_sms_ajax') == -1 && config.url.indexOf('other/login_out') == -1 && config.url.indexOf('other/team_info_edit') == -1 && config.url.indexOf('other/team_info_add') == -1 && config.url.indexOf('vip/newActivateCard') == -1 && config.url.indexOf('other/team_info') == -1 && config.url.indexOf('Sim/planSubmit') == -1 && config.url.indexOf('sim/getSpecialList') == -1 && config.url.indexOf('video/getVideoUrl') == -1 && config.url.indexOf('Evaluation/getHistoryRecordDetail') == -1 && config.url.indexOf('school_tools/schoolDiff') == -1 && config.url.indexOf('User/regist') == -1 && config.url.indexOf('User/sendRegistSms') == -1 && config.url.indexOf('User/forgetPassword') == -1 && config.url.indexOf('User/sendForgetSms') == -1 && config.url.indexOf('User/loginPassword') == -1 && config.url.indexOf('Sim/getHistoryData') == -1 && config.url.indexOf('web/User/geetest') == -1&& config.url.indexOf('web/vip/check_activate') == -1 && config.url.indexOf('web/vip/check_vip') == -1 && config.url.indexOf('web/user/card_type') == -1 && config.url.indexOf('/api/school/getSearchSchoolList') == -1 && config.url.indexOf('web/special/geSearchSpecialList') == -1 && config.url.indexOf('web/school/getSchoolSpecialDetail') == -1 && config.url.indexOf('web/job/getPositionDetail') == -1 && config.url.indexOf('web/job/getSearchJobList') == -1 && config.url.indexOf('web/psytest/submit_answer') == -1 && config.url.indexOf('web/sim/planSmartSubmit') == -1 && config.url.indexOf('web/sim/planEdit') == -1 && config.url.indexOf('other/del_fav') == -1 && config.url.indexOf('other/add_fav') == -1 && config.url.indexOf('school/get_hot_level2') == -1 && config.url.indexOf('school/get_hot_special_list') == -1) {
            requestCount = store.state.user.requestCount;
            requestCount++;
            store.commit('user/ADDCOUNT', requestCount);
        }
        config.cancelToken = new axios.CancelToken((cancel) => {
            //使用vuex 定义pushCancel，请求进来存入
            store.dispatch('user/PUSH_CANCEL', { cancelToken: cancel })
        });
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.status == 403) {
            Message({
                message: '会员已过期',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(res.message || 'Error'))
        } else if (res.status == 401 || res.status == 301) {
            if (response.config.url.indexOf('vip/check_activate') != -1) {
                return res
            }
            store.dispatch('user/CLEAR_CANCEL');
            store.commit('user/LOGINSTATUS', true);
            return Promise.reject(new Error(res.message || 'Error'))
        }  else if (res.status == 400) {
            if (response.config.url.indexOf('user/login') != -1 || response.config.url.indexOf('User/regist') != -1 || response.config.url.indexOf('Sim/getHistoryData') != -1) {
                return res
            } else if(response.config.url.indexOf('getSchoolSpecialLine') != -1) {
                requestCount--;
                if (requestCount >= 0) {
                    store.commit('user/ADDCOUNT', requestCount);
                }
                return res
            }
            Message({
                message: res.message || '请求错误，请稍后再试',
                type: 'warning',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            if (response.config.url.indexOf('School/getSingleSpecia') == -1 && response.config.url.indexOf('user/login') == -1 && response.config.url.indexOf('user/send_sms_ajax') == -1 && response.config.url.indexOf('other/login_out') == -1 && response.config.url.indexOf('other/team_info_edit') == -1 && response.config.url.indexOf('other/team_info_add') == -1 && response.config.url.indexOf('vip/newActivateCard') == -1 && response.config.url.indexOf('other/team_info') == -1 && response.config.url.indexOf('sim/getSpecialList') == -1 && response.config.url.indexOf('Sim/planSubmit') == -1 && response.config.url.indexOf('Evaluation/getHistoryRecordDetail') == -1 && response.config.url.indexOf('school_tools/schoolDiff') == -1 && response.config.url.indexOf('User/regist') == -1 && response.config.url.indexOf('User/sendRegistSms') == -1 && response.config.url.indexOf('User/forgetPassword') == -1 && response.config.url.indexOf('User/sendForgetSms') == -1 && response.config.url.indexOf('User/loginPassword') == -1 && response.config.url.indexOf('Sim/getHistoryData') == -1 && response.config.url.indexOf('web/User/geetest') == -1 && response.config.url.indexOf('web/vip/check_activate') == -1&& response.config.url.indexOf('web/vip/check_vip') == -1 && response.config.url.indexOf('web/user/card_type') == -1&& response.config.url.indexOf('/api/school/getSearchSchoolList') == -1 && response.config.url.indexOf('web/special/geSearchSpecialList') == -1 && response.config.url.indexOf('web/school/getSchoolSpecialDetail') == -1 && response.config.url.indexOf('web/job/getPositionDetail') == -1 && response.config.url.indexOf('web/job/getSearchJobList') == -1 && response.config.url.indexOf('web/psytest/submit_answer') == -1 && response.config.url.indexOf('web/sim/planSmartSubmit') == -1 && response.config.url.indexOf('web/sim/planEdit') == -1 && response.config.url.indexOf('other/del_fav') == -1 && response.config.url.indexOf('other/add_fav') == -1 && response.config.url.indexOf('school/get_hot_level2') == -1 && response.config.url.indexOf('school/get_hot_special_list') == -1) {
                requestCount--;
                if (requestCount >= 0) {
                    store.commit('user/ADDCOUNT', requestCount);
                }
            }
            return res
        }
    },
    error => {
        if (axios.isCancel(error)) {
            // 使用isCancel 判断是否是主动取消请求
            return new Promise(() => { });
        } else {
            Message({
                message: '无法连接网络，请稍后再试',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(error)
        }
    }
)

export default service
